export const REVENUE = "REVENUE";
export const EXPENDITURE = "EXPENDITURE";
export const AUDIT = "AUDIT";
export const SET_FISCAL = "SET_FISCAL";
export const SET_REVENUE_CHARTS = "SET_REVENUE_CHARTS";
export const SET_EXPENDITURE_CHARTS = "SET_EXPENDITURE_CHARTS";
export const SET_AUDIT_INFRACTION = "SET_AUDIT_INFRACTION";